import { ColDef, GridApi, GridReadyEvent, IDatasource, IGetRowsParams } from 'ag-grid-community'
import { colors } from 'assets/theme'
import { StyledAgGridReact } from 'assets/theme/StyledComponents'
import { StyledGridWrapper } from 'assets/theme/StyledGridWrapper'
import React, { useEffect, useState } from 'react'
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas'
import { getChartData } from 'redux/chart/api'

const TRADE_COLOR = {
  'BUY': colors.accents.good.base,
  'SELL': colors.accents.bad.base,
  'STOPOUT': colors.accents.aware.base,
}

function calculateProfit(entry: number, exit: number, trade: string) {
  if (trade === 'BUY') {
    return (exit - entry).toFixed(2);
  }
  return (entry - exit).toFixed(2)
}

const columnDef: ColDef[] = [
  {
    autoHeight: true,
    cellRenderer: (params) => {
      if (params.value === undefined) { return ``; }
      const { last_trade, last_trade_entry, last_trade_exit, last_trade_trend_count, instrument, time } = params.value

      const period = parseInt(instrument.replace( /^\D+/g, ''), 10);
      const tradestart = new Date(time * 1000)
      let duration = '0'
      let stringDate = ''
      switch(period) {
        case 1:
          tradestart.setTime(tradestart.getTime() + (60 * 1000))
          stringDate = tradestart.toLocaleString()
          duration = `${last_trade_trend_count}m`
          break;
        case 5:
          tradestart.setTime(tradestart.getTime() + (5 * 60 * 1000))
          stringDate = tradestart.toLocaleString()
          duration = `${parseInt(last_trade_trend_count, 10) * 5}m`
          break;
        case 60:
          tradestart.setTime(tradestart.getTime() + (60 * 60 * 1000))
          stringDate = tradestart.toLocaleString()
          duration = `${last_trade_trend_count}hr`
          break;
      }
      return `
        <div style='display: grid; grid-template-columns: 1fr 1fr;'>
          <div>Type</div>
          <div style='background: ${TRADE_COLOR[last_trade]}'>${last_trade}</div>
          <div>Entry</div>
          <div>${last_trade_entry ? last_trade_entry.toFixed(2) : ''}</div>
          <div>Exit</div>
          <div>${last_trade_exit ? last_trade_exit.toFixed(2) : ''}</div>
          <div>Unit profit</div>
          <div>${last_trade_exit && last_trade_entry ? calculateProfit(last_trade_entry, last_trade_exit, last_trade) : ''}</div>
          <div>Duration</div>
          <div>${duration}</div>
          <div>Date</div>
          <div>${stringDate}</div>
        </div>
      `
    },
    headerName: 'Historical Trades',
    valueGetter: (params) => params.data,
    width: 300
  },

]

export const HistoricalStMomoTrades: React.FunctionComponent<{ instrument: string, id: number}> = ({ instrument, id }) => {
  const [gridApi, setGridApi] = useState<GridApi>()

  useEffect(() => {
    subscribeListener('store:connected', id, ({ data }: any) => {
      if (gridApi && data === WebSocket.OPEN) {
        gridApi.refreshInfiniteCache()
      }
    });

    return () => unsubscribeListener('store:connected', id);
  }, [gridApi, id]);

  useEffect(() => {
    subscribeListener(`lasttrade:VPM${instrument}`, id, ({ data }) => {
      if (gridApi) {
        gridApi.refreshInfiniteCache()
      }
    })
    return () =>  unsubscribeListener(`lasttrade:VPM${instrument}`, id)
  }, [gridApi, id, instrument])

  useEffect(() => {
    if (gridApi) {
    const dataSource: IDatasource = {
      getRows: async (params: IGetRowsParams) => {
        const query=`stmomo/trades?model=VPM${instrument}&startRow=${params.startRow}&endRow=${params.endRow}`
        try {
          const results = await getChartData(query)
          if (Array.isArray(results.data)) {
            params.successCallback(results.data.map((item: any) => ({
              instrument,
              ...item
            }))
            )
          } else {
            params.failCallback()
          }
        } catch (e) {
          params.failCallback()
        }
      },
      rowCount: undefined,
    }
    gridApi.setDatasource(dataSource)
    }
  }, [gridApi, instrument])

  const onGridReady = (event: GridReadyEvent) => {
    setGridApi(event.api)
  }
  return (
    <StyledGridWrapper fixedRowHeight={false}>
      <StyledAgGridReact
        columnDefs={columnDef}
        onGridReady={onGridReady}
        rowModelType='infinite'
        infiniteInitialRowCount={25}
        paginationPageSize={25}
        maxBlocksInCache={10}
        rowHeight={120}
      />
    </StyledGridWrapper>
  )
}
